<template>
  <div style="min-height: 92vh">
    <h3>Subreceta AYB</h3>
    <uv-data-table :config="config" :data="global_prod" :pageRows="15" @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"></uv-data-table>
    <modal v-model="showModal" :showFooter="false" :fullscreen="true" title="Subreceta">
      <ProductosForm :costos="costos" :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </ProductosForm>
    </modal>
    <modal v-model="showModalModificador" :showFooter="false" title="Modificadores Productos">
      <ProductosModificadores :edit="editMode" :key="formIndex" @toggle="showModalModificador = false"
        :dataEdit="editData" @successData="saveModificadores" />
    </modal>
    <modal v-model="showModalPrecio" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioForm :edit="editMode" :key="formIndex" @toggle="showModalPrecio = false" :dataEdit="editData">
      </ProductoPrecioForm>
    </modal>
    <modal v-model="showModalPrecioPorcentaje" :showFooter="false" title="Modificar Precios">
      <ProductoPrecioProcentajeForm :edit="editMode" :key="formIndex" @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData">
      </ProductoPrecioProcentajeForm>
    </modal>
    <modal v-model="showModalExport" :showFooter="false" title="Exportar a excel"><v-row>
        <v-col cols="12" md="12" class="mb-n6">
          <h3>Seleccione un departamento</h3>
          <v-autocomplete @input="genDataExcel()" v-model="selectedDpto" label="Departamento" :items="modulos">
          </v-autocomplete>
        </v-col>
        <v-col cols="8" md="8" class="mb-n6"> </v-col>
        <v-col cols="4" md="4" class="text-right">
          <v-btn v-if="dataExcel.length > 0" color="green" dark><v-icon>mdi-file-excel-box</v-icon>
            <download-excel type="xls" name="SubRecetas - Productos AYB" :data="dataExcel">
              Generar Excel
            </download-excel>
          </v-btn>
        </v-col>
      </v-row>
    </modal>
    <modal v-model="showModalRecetario" :showFooter="false" title="Exportar recetario"><v-row>
        <v-col cols="12" md="12" class="mb-n6">
          <h3>Seleccione un departamento</h3>
          <v-autocomplete v-model="selectedDpto" label="Departamento" :items="modulos">
          </v-autocomplete>
          <h3>Seleccione una categoria para generar</h3>

          <v-autocomplete v-model="selectedCat" multiple label="Categoria" @change="handleSelectChange"
            :items="CategoriesList" item-value="id" item-text="Nombre">
          </v-autocomplete>
        </v-col>
        <v-col cols="8" md="8" class="mb-n6"> </v-col>
        <v-col cols="4" md="4" class="text-right">
          <v-btn v-if="selectedDpto" @click="genRecetario()" color="red" dark>
            Generar Recetario
          </v-btn>
        </v-col>
      </v-row>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProductosForm from "./InsumosCompuestosForm.vue";
import ProductoPrecioForm from "../../Inventarios/Productos/ProductoPrecioForm.vue";
import ProductoPrecioProcentajeForm from "../../Inventarios/Productos/ProductoPrecioPorcentajeForm.vue";
import ProductosModificadores from "../../Inventarios/Productos/ProductosModificadores.vue";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { mapActions } from "vuex";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteRecetas from "../../../clases/PdfMakers/Recetario.js";
import moment from "moment";
export default {
  name: "InsumosCompuestosCRUD",
  components: {
    modal,
    uvDataTable,
    ProductosForm,
    ProductoPrecioForm,
    ProductoPrecioProcentajeForm,
    ProductosModificadores,
  },
  props: [],
  data() {
    return {
      costos: {},
      selectedDpto: null,
      selectedCat: ["ALL"],
      dataExcel: [],
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      familias: [],
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      showModalExport: false,
      showModalRecetario: false,
      zonas: [],
      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "Insumos compuestos",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addProducto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProducto",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteProducto",
            require: true,
          },
          {
            text: "Exportar a Excel",
            icon: "lni lni-database",
            buttonId: "exportExcel",
            require: false,
          },
          {
            text: "Recetario",
            icon: "lni lni-library",
            buttonId: "exportRecetario",
            require: false,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Rendimiento",
            value: "Rm",
          },
          {
            text: "Unidad Medida",
            value: "UM",
            canBeFiltered: true,
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Tipo",
            value: "Tipo",
            canBeFiltered: true,
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            canBeFiltered: true,
            text: "Familia",
            value: "Familia",
          },
          {
            text: "Departamentos",
            value: "Departamentos",
            canBeFiltered: true,
          },
          {
            text: "Existencia",
            value: "existenciaData", //'Existencia',
            format: (row) => {
              let html = "";
              row["existenciaData"].forEach((element) => {
                html +=
                  "<span>&#8226;</span> " +
                  element.NombreOrigen +
                  ": " +
                  element.Price.Stock +
                  "<br/>";
              });
              return html;
            },
          },
          {
            text: "Costo",
            value: "Costeo",
            format: (row) => {
              let html = "";
              if (row["Costeo"]) {
                row["Costeo"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.depto +
                    ": " +
                    this.$pgsHelper.formatNumber(element.cto.C) +
                    " " +
                    element.cto.M +
                    "<br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
          {
            text: "Ultimo Costo",
            value: "CosteoUltimo",
            format: (row) => {
              let html = "";
              if (row["CosteoUltimo"]) {
                row["CosteoUltimo"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.depto +
                    ": " +
                    this.$pgsHelper.formatNumber(element.uct.C) +
                    " " +
                    element.uct.M +
                    "<br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editPrecio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "exportRecetario") {
        this.showModalRecetario = true;
      }
      if (buttonId == "adminModificadores") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalModificador = true;
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
      if (buttonId == "exportExcel") {
        this.showModalExport = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    genRecetario() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        let prodCopy = this.$pgsHelper.cloneObj(element);
        if (prodCopy.Tipo == "AYB-ICompuesto" && !prodCopy.Dlat) {
          if (prodCopy?.Departamentos.includes(this.selectedDpto)) {
            if (
              this.selectedCat.includes(prodCopy.Categoria) ||
              this.selectedCat.includes("ALL")
            ) {
              /*if(prodCopy.CCs){
                if(prodCopy.CCs[0][this.selectedDpto][0] != "-NTTx2yfPNM81JCu4e1g"){
                  return false
                }
              }*/
              prodCopy.categoria_name = this.getCategoryById(
                prodCopy.Categoria
              ).Nombre;
              let Familia = this.getCategoryById(prodCopy.Categoria)
                ? this.getCategoryById(prodCopy.Categoria).Familia
                : "";
              prodCopy.Familia = this.$pgsHelper.getById(
                this.familias,
                "id",
                Familia
              )
                ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
                : "";
              prodCopy.Costeo = this.costos[prodCopy.id];
              let Costo = 0;
              let CostoMoneda = "";
              if (prodCopy.Costeo) {
                let costeDepto = this.$pgsHelper.getById(
                  prodCopy.Costeo,
                  "depto",
                  this.selectedDpto
                );
                if (costeDepto) {
                  Costo = costeDepto.uct.C;
                  CostoMoneda = costeDepto.uct.M;
                }
              }
              prodCopy.Catalogo.forEach((insumo) => {
                let producto = this.$pgsHelper.getById(prod, "id", insumo.Id);
                insumo.Nombre = producto.Nombre;
                insumo.UM = insumo.Extra.AYB.UM;
                insumo.Mm = insumo.Extra.AYB.Mm;
                let costoInsumo = this.costos[insumo.Id];
                if (costoInsumo) {
                  let costeDeptoInsumo = this.$pgsHelper.getById(
                    costoInsumo,
                    "depto",
                    this.selectedDpto
                  );
                  if (costeDeptoInsumo) {
                    let CostoInsm = costeDeptoInsumo.uct.C;
                    let CostoMonedaInsm = costeDeptoInsumo.uct.M;
                    insumo.Costo = this.$pgsHelper.formatNumber(CostoInsm);
                    insumo.MonedaCosto = CostoMonedaInsm;
                  } else {
                    insumo.Costo = 0;
                    insumo.MonedaCosto = "";
                  }
                } else {
                  insumo.Costo = 0;
                  insumo.MonedaCosto = "";
                }
              });
              productos.push({
                Codigo: prodCopy.Codigo,
                Receta: prodCopy.Nombre,
                Departamento: this.selectedDpto,
                Categoria: prodCopy.categoria_name,
                Familia: prodCopy.Familia,
                Costo: this.$pgsHelper.formatNumber(Costo),
                MonedaCosto: CostoMoneda,
                Precio: this.$pgsHelper.formatNumber(prodCopy.Precio),
                Moneda: prodCopy.Moneda,
                ...prodCopy,
              });
            }
          }
        }
      });

      let orderedProds = this.$_.orderBy(productos, "Categoria", "asc");

      let tenant = this.$store.getters.getFirebaseApp.tenant;
      let CategoriasName = [];
      this.selectedCat.forEach((cat) => {
        CategoriasName.push(
          this.$pgsHelper.getById(this.Categories, "id", cat).Nombre
        );
      });
      let mainData = {
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        TITLE: "RECETAS",
        Departamento: this.selectedCat,
        Productos: orderedProds,
        CateName: CategoriasName.join(" - "),
      };
      if (this.selectedCat.includes("ALL")) {
        mainData.CateName = "Todos";
      }
      let docData = ReporteRecetas.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    handleSelectChange() {
      if (
        this.selectedCat.includes("ALL") &&
        this.selectedCat.some((item) => item !== "ALL")
      ) {
        // Si "ALL" está seleccionado junto con otros, elimina "ALL" y deja los otros
        let lengthSelected = this.selectedCat.length;
        if (this.selectedCat[lengthSelected - 1] == "ALL") {
          this.selectedCat = ["ALL"];
        } else {
          this.selectedCat = this.selectedCat.filter((item) => item !== "ALL");
        }
      }
    },
    genDataExcel() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        if (element.Tipo == "AYB-ICompuesto" && !element.Dlat) {
          if (element?.Departamentos.includes(this.selectedDpto)) {
            element.categoria_name = this.getCategoryById(
              element.Categoria
            ).Nombre;
            let Familia = this.getCategoryById(element.Categoria)
              ? this.getCategoryById(element.Categoria).Familia
              : "";
            element.Familia = this.$pgsHelper.getById(
              this.familias,
              "id",
              Familia
            )
              ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
              : "";
            element.Costeo = this.costos[element.id];
            let Costo = 0;
            let CostoMoneda = "";
            if (element.Costeo) {
              let costeDepto = this.$pgsHelper.getById(
                element.Costeo,
                "depto",
                this.selectedDpto
              );
              if (costeDepto) {
                Costo = costeDepto.cto.C;
                CostoMoneda = costeDepto.cto.M;
              }
            }
            element.Catalogo.forEach((insumo) => {
              let insumoData = this.$pgsHelper.getById(prod, "id", insumo.Id);
              productos.push({
                Codigo: element.Codigo,
                RecetaId: element.id,
                Receta: element.Nombre,
                InsumoID: insumo.Id,
                Insumo: insumoData ? insumoData.Nombre : "",
                Departamento: this.selectedDpto,
                Categoria: element.categoria_name,
                Familia: element.Familia,
                Etiquetas: element.tags,
                Costo: this.$pgsHelper.formatNumber(Costo),
                MonedaCosto: CostoMoneda,
                Precio: this.$pgsHelper.formatNumber(element.Precio),
                Moneda: element.Moneda,
              });
            });
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let orderedProds = this.$_.orderBy(productos, "Categoria", "asc");

      this.dataExcel = orderedProds;
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    async deleteProducto(id) {
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "la subreceta",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_DELETE",
            Mensaje: "Producto eliminado ",
            reference: { id: id, tp: "AYB-ICompuesto", al: "Insumo Compuesto" },
            data: deletedObject
          });
          this.getCategories();
        },
      });
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "la subreceta",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "AYB-ICompuesto", al: "Insumo Compuesto" },
            data: datos
          });
          this.toggleModal(false);
          this.getCostos();
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "la subreceta",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: (result) => {
          const targetId = result?.data?.id || result?.data?.data?.id || datos.id;
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_CREATE",
            Mensaje: "Producto creado",
            reference: { id: targetId, tp: "AYB-ICompuesto", al: "Insumo Compuesto" },
            data: datos
          });
          this.toggleModal(false);
          this.getCostos();
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_EDIT",
            Mensaje: "Producto editado",
            reference: { id: datos.id, tp: "AYB-ICompuesto", al: "Insumo Compuesto" },
            data: datos
          });
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.$pgsHelper.cloneObj(this.global_prod[itemIndex]);
      }

      return false;
    },
    async getProducts() { },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
  },
  computed: {
    CategoriesList() {
      let data = [{ id: "ALL", Nombre: "TODOS" }];
      this.Categories.forEach((cate) => {
        data.push(cate);
      });
      return data;
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (this.getCategoryById(element.Categoria).ZImp) {
          element.ZImp = this.$pgsHelper.getById(
            this.zonas,
            "Id",
            this.getCategoryById(element.Categoria).ZImp
          ).nomb;
        } else {
          element.Zimp = "Default";
        }
        if (element.Tipo == "AYB-ICompuesto" && !element.Dlat) {
          let Familia = this.getCategoryById(element.Categoria)
            ? this.getCategoryById(element.Categoria).Familia
            : "";
          element.Familia = this.$pgsHelper.getById(
            this.familias,
            "id",
            Familia
          )
            ? this.$pgsHelper.getById(this.familias, "id", Familia).Nombre
            : "";
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        producto.UM = producto.Extra?.AYB?.UM || "PZ";
        producto.Rm = producto.Extra?.AYB?.Rm || 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });
        producto.Costeo = this.costos[producto.id];
        producto.CosteoUltimo = this.costos[producto.id];
        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      let data = productos;
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getFamilias();
    this.getCategories();
    this.getZonasImpresion();
    this.getCostos();
    //this.getProducts();
  },
};
</script>
